import { Reveal } from "./Reveal";
import { CLINIC } from "../lib/content";
import { MapPin, Phone, Mail, Clock, ArrowUpRight } from "lucide-react";

export default function Location() {
  return (
    <section id="location" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <span className="overline text-accent">Visit the clinic</span>
          <h2 className="font-serif text-primary text-4xl sm:text-5xl tracking-tight leading-[1.02] mt-5 max-w-xl">
            Find us at Mom &amp; More, Mahadevapura.
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-3 gap-5">
          <Reveal className="lg:col-span-2">
            <div className="overflow-hidden rounded-[1.5rem] border border-border h-[320px] sm:h-[440px]">
              <iframe
                title="Mom and More Clinic location"
                data-testid="location-map"
                src={CLINIC.mapEmbed}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="h-full rounded-[1.5rem] border border-border bg-card p-8 flex flex-col justify-between gap-8">
              <div className="space-y-6">
                <div className="flex gap-4">
                  <MapPin className="text-accent shrink-0" size={20} />
                  <div>
                    <p className="font-semibold text-foreground text-sm">Address</p>
                    <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{CLINIC.address}</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Phone className="text-accent shrink-0" size={20} />
                  <div>
                    <p className="font-semibold text-foreground text-sm">Phone</p>
                    <a href={`tel:${CLINIC.phone.replace(/\s/g, "")}`} className="text-sm text-muted-foreground mt-1 hover:text-primary transition-colors">{CLINIC.phone}</a>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Mail className="text-accent shrink-0" size={20} />
                  <div>
                    <p className="font-semibold text-foreground text-sm">Email</p>
                    <a href={`mailto:${CLINIC.email}`} className="text-sm text-muted-foreground mt-1 hover:text-primary transition-colors">{CLINIC.email}</a>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Clock className="text-accent shrink-0" size={20} />
                  <div>
                    <p className="font-semibold text-foreground text-sm">Hours</p>
                    <ul className="text-sm text-muted-foreground mt-1 space-y-1">
                      {CLINIC.hours.map((h) => (
                        <li key={h.d} className="flex justify-between gap-4">
                          <span>{h.d}</span>
                          <span className="text-foreground/70">{h.t}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <a
                href={CLINIC.mapLink}
                target="_blank"
                rel="noreferrer"
                data-testid="directions-link"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-accent text-accent-foreground px-6 py-3.5 text-sm font-bold hover:-translate-y-0.5 transition-transform duration-300"
                style={{ boxShadow: "0 12px 28px -10px rgba(228,71,122,0.55)" }}
              >
                Get directions <ArrowUpRight size={17} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
